import { BrandTypes } from '@ps/platform-message-framework/common/BrandTypes';
import { Country } from '@ps/web-core-enums';
import { canUseDOM } from '@ps/web-core-utils';
import { Translation } from '@ps/web-shared-components';
import { StarsLink } from '@ps/web-shared-ui';
import React from 'react';
import { useSelector } from 'react-redux';

import useWizardContext from '@swf/core/hooks/useWizardContext';
import { select } from '@swf/core/store';

import { getCountryStates } from '../../../../utils/country-states/country-states';
import Button from '../../../Button/Button';
import Container from '../../../Container/Container';

import {
  TXTWCL_Download_the_XXBrandXX_app_for_ELL,
  TXTWCL_Get_the_app,
  TXTWCL_Playing_from_OntarioX
} from './SignupCAONRedirect.messages.json';
import { container, imageContainer } from './SignupCAONRedirect.scss';
import CasinoAppLogo from './assets/casino_app_logo.png';
import CasinoAppLogoOnt from './assets/casino_app_ont.png';
import DefaultAppLogo from './assets/default_app_logo.png';
import DefaultAppLogoOntario from './assets/default_app_logo_ont.png';
import SportAppLogo from './assets/sports_app.png';
import SportAppLogoOntario from './assets/sports_app_ont.png';

const provinceCAON = 'ON';

const CAONAppShortLink = {
  [BrandTypes.POKER_STARS as number]: 'https://amaya.onelink.me/1DWJ',
  [BrandTypes.STARS_CASINO as number]: 'https://amaya.onelink.me/1DWJ',
  [BrandTypes.BET_STARS as number]: 'https://amaya.onelink.me/1DWJ'
};

const COMAppShortLink = {
  [BrandTypes.POKER_STARS as number]: 'https://amaya.onelink.me/329188057',
  [BrandTypes.STARS_CASINO as number]: 'https://amaya.onelink.me/1272627827',
  [BrandTypes.BET_STARS as number]: 'https://amaya.onelink.me/2970558839'
};

const CAONAppImages = {
  [BrandTypes.POKER_STARS as number]: DefaultAppLogoOntario,
  [BrandTypes.STARS_CASINO as number]: CasinoAppLogoOnt,
  [BrandTypes.BET_STARS as number]: SportAppLogoOntario
};

const COMAppImages = {
  [BrandTypes.POKER_STARS as number]: DefaultAppLogo,
  [BrandTypes.STARS_CASINO as number]: CasinoAppLogo,
  [BrandTypes.BET_STARS as number]: SportAppLogo
};

const getAppLink = (isAndroid: boolean, state?: string) => {
  const brand = canUseDOM && window?.starsweb?.app?.brand;
  const storeLinks = state === provinceCAON ? CAONAppShortLink : COMAppShortLink;
  const link = brand ? storeLinks[brand] : storeLinks[1];
  return `${isAndroid ? 'external-' + link : link}`;
};

const getAppLogo = (state?: string) => {
  const brand = canUseDOM && window?.starsweb?.app?.brand;
  const storeLinks = state === provinceCAON ? CAONAppImages : COMAppImages;
  return brand ? storeLinks[brand] : storeLinks[1];
};

const SignupCAONRedirect: React.FunctionComponent = () => {
  const isAndroid = useSelector(select.device.isAndroid);
  const {
    values: { country, state }
  } = useWizardContext();
  const fullStateName = getCountryStates(country || Country.Canada).find(
    (item) => item.value === state
  );

  return (
    <Container
      page={SignupCAONRedirect}
      headerProps={{
        title: (
          <Translation {...TXTWCL_Playing_from_OntarioX} values={{ 0: fullStateName?.text }} />
        ),
        buttons: { back: false }
      }}
    >
      <div className={container}>
        <h2>
          <Translation {...TXTWCL_Playing_from_OntarioX} values={{ 0: fullStateName?.text }} />
        </h2>
        <div className={imageContainer}>
          <img src={getAppLogo(state)} alt="" />
        </div>
        <h4>
          <Translation
            {...TXTWCL_Download_the_XXBrandXX_app_for_ELL}
            values={{ 0: fullStateName?.text }}
          />
        </h4>
        <StarsLink target="_blank" href={getAppLink(isAndroid, state)}>
          <Button translation={TXTWCL_Get_the_app} type="button" isFullWidth />
        </StarsLink>
      </div>
    </Container>
  );
};

SignupCAONRedirect.displayName = 'SignupCAONRedirect';

export default SignupCAONRedirect;
